import * as d3 from 'd3';

type LeftAxisArguments = {
  axisScale: d3.ScaleLinear<number, number, never>;
  tickNumber: number;
  tickSize: number;
  tickPadding: number;
};
type AxisArguments = {
  axisScale: d3.ScaleLinear<number, number, never> | d3.ScaleBand<number>;
  tickValues?: number[];
  tickSize: number;
  tickPadding: number;
  tickSizeOuter: number;
  tickFormat?: (domainValue: d3.NumberValue, index: number) => string;
};

export const createNoDecimalAxisLeft = ({
  axisScale,
  tickNumber,
  tickSize,
  tickPadding,
}: LeftAxisArguments) => {
  const AxisTicks = axisScale
    .ticks(tickNumber)
    .filter((t) => Number.isInteger(t));
  const Axis = d3
    .axisLeft(axisScale)
    .tickSize(tickSize)
    .tickPadding(tickPadding)
    .tickValues(AxisTicks)
    .tickFormat(d3.format('d'));

  return { AxisTicks, Axis };
};

export const createXAxis = ({
  axisScale,
  tickValues,
  tickSize,
  tickPadding,
  tickSizeOuter,
  tickFormat,
}: AxisArguments) => {
  const axis = d3
    .axisBottom(axisScale)
    .tickSize(tickSize)
    .tickPadding(tickPadding)
    .tickSizeOuter(tickSizeOuter);

  if (tickValues) {
    axis.tickValues(tickValues);
  }

  if (tickFormat) {
    axis.tickFormat(tickFormat);
  }

  return { axis };
};
export const createYAxis = ({
  axisScale,
  tickValues,
  tickSize,
  tickPadding,
  tickSizeOuter,
  tickFormat,
}: AxisArguments) => {
  const axis = d3
    .axisLeft(axisScale)
    .tickSize(tickSize)
    .tickPadding(tickPadding)
    .tickSizeOuter(tickSizeOuter);

  if (tickValues) {
    axis.tickValues(tickValues);
  }

  if (tickFormat) {
    axis.tickFormat(tickFormat);
  }

  return { axis };
};
